import type { FetchClient, RequestOptions } from '../../../lib/http/http.types';
import type { GenFilesCurrentResponse, GenFileUploadResult } from '../types/gen-file.types';
import GEN_FILES_ENDPOINTS from './gen-files.endpoints';

export interface GenFilesApi {
  getCurrent(opts?: RequestOptions): Promise<GenFilesCurrentResponse>;
  upload(file: File, opts?: RequestOptions): Promise<GenFileUploadResult>;
}

export function GenFilesApiFactory(client: FetchClient): GenFilesApi {
  return {
    getCurrent: (opts) => client.get<GenFilesCurrentResponse>(GEN_FILES_ENDPOINTS.CURRENT, opts),

    upload: (file, opts) => {
      const form = new FormData();
      form.append('file', file);
      return client.postMultipart<GenFileUploadResult>(GEN_FILES_ENDPOINTS.UPLOAD, form, opts);
    },
  };
}
